import { Controller } from '@hotwired/stimulus';
import { PasswordValidatorController } from '@elc-online/edl-components/js/password_validator';

export default class extends Controller {
  static readonly targets = ['container', 'content', 'meter', 'requirements'];

  declare containerTarget: HTMLElement;
  declare contentTarget: HTMLElement;
  declare meterTarget: HTMLElement;
  declare requirementsTarget: HTMLElement;

  initialize(): void {
    new PasswordValidatorController(
      {
        container: this.containerTarget,
        content: this.contentTarget,
        meter: this.meterTarget,
        requirements: this.requirementsTarget,
      },
      {
        mode: 'auto',
      },
    );
  }
}
